import { subtract } from '@pushpay/styles';
import { createMediaQuery } from './helpers';
const WIDESCREEN_MIN = '1440px';
const DESKTOP_MAX = subtract(WIDESCREEN_MIN, 1);
const DESKTOP_MIN = '1025px';
const TABLET_MAX = subtract(DESKTOP_MIN, 1);
const TABLET_MIN = '768px';
const MOBILE_MAX = subtract(TABLET_MIN, 1);
export const NEVER = '';
export const MOBILE = createMediaQuery({
  maxWidth: MOBILE_MAX
});
export const TABLET_AND_BELOW = createMediaQuery({
  maxWidth: TABLET_MAX
});
export const TABLET_PORTRAIT_AND_BELOW = createMediaQuery({
  maxWidth: TABLET_MAX,
  orientation: 'portrait'
});
export const TABLET = createMediaQuery({
  minWidth: TABLET_MIN,
  maxWidth: TABLET_MAX
});
export const TABLET_PORTRAIT = createMediaQuery({
  minWidth: TABLET_MIN,
  maxWidth: TABLET_MAX,
  orientation: 'portrait'
});
export const TABLET_LANDSCAPE = createMediaQuery({
  minWidth: TABLET_MIN,
  maxWidth: TABLET_MAX,
  orientation: 'landscape'
});
export const TABLET_AND_ABOVE = createMediaQuery({
  minWidth: TABLET_MIN
});
export const TABLET_LANDSCAPE_AND_ABOVE = createMediaQuery({
  minWidth: TABLET_MIN,
  orientation: 'landscape'
});
export const DESKTOP_AND_BELOW = createMediaQuery({
  maxWidth: DESKTOP_MAX
});
export const DESKTOP = createMediaQuery({
  minWidth: DESKTOP_MIN,
  maxWidth: DESKTOP_MAX
});
export const DESKTOP_AND_ABOVE = createMediaQuery({
  minWidth: DESKTOP_MIN
});
export const WIDESCREEN = createMediaQuery({
  minWidth: WIDESCREEN_MIN
});